const initialState = () => ({
  isOpened: false,
  error: null,
  data: {},
  action: null,
  onSuccessCallback: null
});

const ACTION_KEY = 'PAD_EDITOR_PRESCRIPTION_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { data, action } = reduxAction.payload;
      return {
        ...state,
        data,
        action,
        isOpened: true
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
